export default __webpack_public_path__ + "static/media/datadog.92ed276127eb2381a58c14853f5a2f4d.svg";